import { CurrencyMap, } from "@travel/shared/types";
export function transformPrice(value, currency) {
    return {
        currency: CurrencyMap[currency === null || currency === void 0 ? void 0 : currency.toLowerCase()],
        value: value,
    };
}
export var transformPrices = function (rawPrices, currency) {
    var _a;
    if (currency === void 0) { currency = "usd"; }
    var currencyKey = currency.toLowerCase();
    var prices = (_a = {},
        _a[currencyKey] = {
            currency: CurrencyMap[currencyKey],
            value: rawPrices,
        },
        _a);
    return prices;
};
